import { render, staticRenderFns } from "./Zrsqd.vue?vue&type=template&id=775e4114&scoped=true&"
import script from "./Zrsqd.vue?vue&type=script&lang=js&"
export * from "./Zrsqd.vue?vue&type=script&lang=js&"
import style0 from "./Zrsqd.vue?vue&type=style&index=0&id=775e4114&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775e4114",
  null
  
)

export default component.exports